// extracted by mini-css-extract-plugin
export default {"Topbar":"RevisionTopbar_Topbar__si1OX","Title":"RevisionTopbar_Title__47ZVl","BackIcon":"RevisionTopbar_BackIcon__BGuPh","Children":"RevisionTopbar_Children__6+E3P"};